import React, { useState } from 'react';
import './Hero.css';

const taglines = [
  "Unleash Your Voice",
  "The Devil is in the DSPtails",
  "Route to Perfection",
  "Your Signal, Your Rules",
  "Drag. Drop. Destroy."
];

function Hero() {
  const [tagline] = useState(() =>
    taglines[Math.floor(Math.random() * taglines.length)]
  );

  return (
    <section className="hero">
      <div className="container hero-content">
        <img src="/assets/logo.png" alt="DiabloDSP" className="hero-logo" />
        <h1 className="hero-tagline">{tagline}</h1>
        <p className="hero-subtitle">
          Professional multi-effects signal chain with modular routing
        </p>
        <a href="#products" className="hero-cta">
          View Products
        </a>
      </div>
    </section>
  );
}

export default Hero;
